// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Background: '#121214',
  Background2: 'rgb(32, 32, 36)',
  Primary: 'rgba(251, 169, 61, 1)',
  Secondary: 'rgba(205, 46, 90, 1)',
  Borders: '#323238',
  Red: '#ce4a4a',
  Blue: '#00aaff',
  Yellow: '#ffcd1e',
  Green: '#04d361',
  White: '#fff',
  Black: '#09090a',
  Text: '#a8a8b3',
  GradientBlue: 'linear-gradient(225deg, #00aaff, #09090a)',
  GradientRed: 'linear-gradient(225deg, #ce4a4a, #09090a)',
  GradientGrey: 'linear-gradient(225deg, #323238, #09090a)',
};
